const STORAGE_KEY = 'selectedGST';
const EVENT_NAME = 'gstSelectionChanged';

export function getSelectedGSTFromStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    console.error('Error parsing saved GST from localStorage');
    localStorage.removeItem(STORAGE_KEY);
    return null;
  }
}

export function setSelectedGSTAndBroadcast(gst) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(gst));
  window.dispatchEvent(
    new CustomEvent(EVENT_NAME, { detail: { selectedGST: gst } })
  );
}

export { STORAGE_KEY, EVENT_NAME };
